import Vue from 'vue';
import gaService from './ga.service';

export default {
  async getNotAppliedWithdrawPins() {
    return (await Vue.http.get('/api/pins/withdrawpins')).data;
  },
  async apply(pincode, preferredBonusType) {
    let activationResult = (await Vue.http.post('/api/pins/apply', { pincode, preferredBonusType })).data;
    if (activationResult.isSuccess) {
      gaService.send('pins', 'applying', activationResult.playerName, activationResult.pin.value);
    }
    return activationResult;
  },
  async getLastWithdrawalPin() {
    return (await Vue.http.get('/api/pins/lastwithdrawal')).data;
  }
}



// WEBPACK FOOTER //
// ./_common/services/pin.service.js